import React, { useContext, useEffect,setC } from "react";
import GlobalContext from "../../context/GlobalContext";
import BasicCard from "./../common/BasicCard";
import { useParams } from "react-router-dom";
import { MainTitle } from "../styled/Typography";
import PopUpAdDialog from "./PopUpAdDialog";
import ClientLogDialog from "./ClientLogDialog";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import BannerRenderer from "./../common/BannerRenderer";


const MenuChooser = (props) => {
  const context = useContext(GlobalContext);
  const { restaurantId } = useParams();

  let tint = props?.tintScreen;

  const renderLogo = () => {
    const logoUrl = context.configuration.restaurantDetails.logo;
    const parallaxUploaded = context.configuration.restaurantDetails.parallaxUploaded;

    const noLogo = logoUrl === "" || logoUrl === null || logoUrl === undefined;
    return (
      <div style={{ filter: context.blur}}>
        {noLogo ? (
          <div style={{ paddingTop: 30, paddingBottom: 30 }}>
            <MainTitle>
              {context.configuration.restaurantDetails.name}
            </MainTitle>
          </div>
        ) : (
          // <img src={logoUrl} style={{ height: "auto", width: "100%", paddingTop: 0 }} />
          <LazyLoadImage
            effect="blur"
            style={{ height: "auto", width: "100%", paddingTop: 0 }}
            src={logoUrl} // use normal <img> attributes as props
            width="100%"
          />
        )}
      </div>
    );
  };
  useEffect(() => {
    //window.scrollTo(0, 0)
    //console.log("brane")
    //window.scrollTo({top: 0, behavior: 'smooth'});
    document.documentElement.scrollTo(0, 0);
    //document.querySelector('body').scrollTo(0,0);
  }, []);
  const renderItems = () => {
    return Object.keys(context.menu).map((obj) => (
      <BasicCard
        key={obj}
        to={"/" + restaurantId + "/categories" + context.menu[obj].url + context?.configuration?.table}
        title={context.menu[obj].name}
        image={context.menu[obj].image}
      />
    ));
  };


  const renderPopUpAdDialog = () => {
    return <PopUpAdDialog popUpAd={context.configuration.popUpAd} />;
  };

  const renderClientLogDialog = () => {
    return <ClientLogDialog />;
  };

  const getBackgroundStyle = () => {
    let style = { paddingTop: 0 };
    style.filter = tint ? "blur(1.3rem)" : ""
    // if(context.configuration.restaurantDetails.parallaxUploaded !== "" && context.configuration.restaurantDetails.parallaxUploaded.startsWith("http")){
    //   console.log("vlagaa")
    //   style.backgroundImage = `url(${context.configuration.restaurantDetails.parallaxUploaded})`;
    //   /* Set a specific height */
    //   style.minHeight= "100%";
    //   /* Create the parallax scrolling effect */
    //   style.backgroundAttachment= "fixed";
    //   style.backgroundPosition= "center";
    //   style.backgroundRepeat= "no-repeat";
    //   style.backgroundSize= "cover";
    // }
    return style;
  };

  // let it stay, we might need it.

  // const setUpWebSocket = async () => {
  //   console.log("SET UP WEB SOCKET");
  //   var W3CWebSocket = require("websocket").w3cwebsocket;

  //   var client = new W3CWebSocket(`${process.env.REACT_APP_WEB_SOCKET_URL}`);

  //   return client;
  // };


  return  <div className="scroll-content" style={getBackgroundStyle()}>
      {renderLogo()}
      {renderItems()}
      {renderPopUpAdDialog()}
      {renderClientLogDialog()}
      {context.banner && <BannerRenderer image={context.configuration?.restaurantDetails?.banner}  link={context.configuration?.restaurantDetails?.bannerLink} linkEnabled={context.configuration?.restaurantDetails?.bannerLinkEnabled} />}
      
    </div>
};

export default MenuChooser;
